import { NgModule } from '@angular/core';
import { SharedProviderModule } from '../shared/shared.module';
import { ToolbarComponent } from './toolbar.component';
import { SearchModule } from '../components/search/search.module';
import { IntercomService } from '../shared/intercom.service';
import { FavoriteService } from './favorite/favorite.service';
import { StateService } from '../shared/state/state.service';
import { OverlayPanelModule } from '../components/overlay-panel/overlay-panel.module';
import { WeatherModule } from '../weather/weather.module';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';
import { QmDirectivesModule } from '../components/qm-directives/qm-directives.module';
import { VrgroupModule } from '../custom/vrgroup/vrgroup.module';
import { NgbDropdownModule, NgbModalModule, NgbPopoverModule, NgbTabsetModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UserSettingsModule } from '../components/user-settings/user-settings.module';
import { MonitorsModule } from '../components/monitors/monitors.module';
import { NeveModule } from '~app/custom/neve/neve.module';


@NgModule({
  imports: [
    SharedProviderModule,
    QmPipesModule,
    QmDirectivesModule,
    OverlayPanelModule,
    WeatherModule,
    VrgroupModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbTabsetModule,
    SearchModule,
    UserSettingsModule,
    MonitorsModule,
    NeveModule,
  ],
  declarations: [ToolbarComponent],
  exports: [ToolbarComponent],
  providers: [StateService, FavoriteService, IntercomService]
})
export class ToolbarModule {
}
